<template>
  <TheFooter fixed>
    <!--footer-->
    <b-row>
      <b-col cols="10">
        <div id="footer_go_left">
          <div id="footer_logo_wrap">
            <div id="footer_logo"></div>
          </div>
          <div id="footer_link">
            <ul>
              <li>© INCA Internet Corporation. All rights reserved.</li>
              <!-- <li><a href="/kr/pri_supp/pri_supp.html" style="font-weight:bold;">개인정보 처리방침</a></li>
              <li><a href="/kr/pri_supp/pri_supp.html#vision_em">이메일 수집 거부</a></li> -->
            </ul>
          </div>
          <div id="footer_address">
            <ul>
              <li>서울특별시 강서구 마곡중앙14로 53 (주) 잉카인터넷</li>
              <li>대표번호 02-6411-8000</li>
              <li>고객지원 1566-0808</li>
              <li>Fax 02-6411-8080</li>
              <li>통신판매업신고번호 제2021-서울강서-4201호</li>
              <li>사업자등록번호 214-86-47888</li>
              <li>대표 주영흠</li>
            </ul>
          </div>
        </div>
      </b-col>
      <b-col cols="2">
        <div id="footer_go_right">
          <div id="family_menu" class="footer_menu">
            <ul>
              <li class="footer_content" :class="{active_all: isActive}" @click="isActive = !isActive">패밀리 사이트
                <ul class="footer_menu_content">
                  <li><a href="https://inca.co.kr" target="_blank">INCA</a></li>
                  <li><a href="https://nprotect.com" target="_blank">nProtect</a></li>
                  <li><a href="https://tachyonlab.com" target="_blank">TACHYON</a></li>
                  <li><a href="https://isarc.tachyonlab.com/" target="_blank">ISARC Blog</a> </li>
                  <li><a href="https://blog.naver.com/inca_internet" target="_blank">NAVER Blog</a> </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </b-col>
    </b-row>

<!--
    <div>
      <a
        href="https://nprotect.com"
        target="_blank"
      >
        <img
          src="images/logo_ci_white.png"
          style="width:33px;height:21px;"
        />
      </a>
    </div>
    <div class="ml-auto">
      <span class="mr-1">&copy; INCA Internet Corporation. All rights reserved.</span>
    </div>
-->
  </TheFooter>
</template>

<script>
import { Footer as TheFooter } from '@coreui/vue'
import { toggleBodyClass } from '@/shared/utils'

export default {
  name: 'MainFooter',
  components: {
    TheFooter,
  },
  data () {
    return {
      isDevelopMode: !(process.env.NODE_ENV === 'production'),
      isActive: false
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  },
  beforeCreate: function () {
    // if (!this.$session.exists() || !DevAuthorize.isLogined(this)) {
    //   this.$router.push('/login')
    // }
  },
  created: function() {

  },
  mounted() {
    toggleBodyClass('removeClass', 'footer-fixed');
  },
  destroyed() {
    // toggleBodyClass('addClass', 'footer-fixed');
  },
  methods: {
  }
}
</script>

<style lang="css" scoped>
.main > div.container-fluid {
  padding: 0 1rem;
}
.footer-fixed .app-footer {
  height: 100px;
}
#footer_bg > #footer_warp {
    margin: 0 auto;
    /* width: 1150px; */
    height: 100px;
}
#footer_go_left {
    float: left;
    line-height: 15px;
    width: 850px;
    height: auto;
    overflow: hidden;
}
#footer_go_right {
    margin-top: 15px;
    /* width: 290px; */
    height: auto;
    float: right;
}
#footer_logo_wrap {
    width: 55px;
    height: 100px;
    float: left;
    margin-right: 25px;
}
#footer_logo {
    width: 55px;
    height: 100px;
    background: url(~@/assets/logo_all_v10.png) left center;
    background-repeat: no-repeat;
}

li {
    list-style: none;
}
#footer_link {
    /* float: left; */
    /* width: 760px; */
    margin-top: 15px;
    font-size: 13px;
    margin-bottom: 5px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}
#footer_link > ul li {
    display: inline-block;
    color: #323232;
    font-size: 12px;
    font-weight: normal;
    line-height: 10px;
    margin-right: 5px;
    padding-right: 10px;
    border-right: 1px solid #323232;
    letter-spacing: 0px !important;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}
#footer_link > ul > li > a {
    color: #323232;
}

a {
    text-decoration: none;
}

#footer_address {
    float: left;
    width: 760px;
    margin-top: 5px;
    font-size: 13px;
    margin-bottom: 5px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}
#footer_address > ul {
      padding-left: 0;
}
#footer_address > ul li {
    display:inline-block;
}

#footer_address > ul > li {
    margin-right:5px;
    padding-right:10px;
    line-height:5px;
    border-right:1px solid #323232;

    -webkit-box-sizing:border-box;
    -moz-box-sizing:border-box;
    box-sizing:border-box;
}

#footer_address > ul > li:last-child {
    border-right:0;
}


#footer_address > ul > li {
    color:#323232;
    font-size:12px;
    font-weight:normal;
    line-height:10px;
    margin-bottom:5px;

    -webkit-box-sizing:border-box;
    -moz-box-sizing:border-box;
    box-sizing:border-box;
}
.footer_menu > ul {
    position: relative;
    float: right;
}
.footer_menu > ul > li {
    font-size: 11px;
    list-style: none;
    color: #323232;
    line-height: 30px;
    cursor: pointer;
    letter-spacing: 0px !important;
    width: 140px;
    height: auto;
    display: block;
    padding: 0px 10px 0px 10px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}
.footer_menu > ul > li > ul {
    position: absolute;
    left: 0;
    bottom: 30px;
    z-index: 99;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}
.footer_menu > ul > li > ul > li {
    background: #f9f9f9;
    border-bottom: 1px solid #eaeaea;
}
.footer_menu > ul > li > ul > li > a {
    color: #323232;
    line-height: 30px;
    width: 140px;
    height: auto;
    display: block;
    padding: 0px 10px 0px 10px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

.footer_content {
    background: url(~@/assets/arrow_lang.png) no-repeat #eeeeee 120px 10px;
}
.footer_content.active_all {
    background: url(~@/assets/arrow_lang_hover.png) no-repeat #d1d1d1 120px 10px;
}

.footer_content .footer_menu_content {
    display: none;
}
.footer_content.active_all .footer_menu_content {
    display: block;
}
#footer_address > ul > li {
    color: #323232;
    font-size: 12px;
    font-weight: normal;
    line-height: 10px;
    margin-bottom: 5px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}
#footer_address > ul > li {
    margin-right: 5px;
    padding-right: 10px;
    line-height: 5px;
    border-right: 1px solid #323232;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}
#footer_address > ul li {
    display: inline-block;
}
</style>
<style>
  footer {
    display: block !important;
  }
  footer .row {
    background: #f0f3f5 !important;
  }
</style>